export default __webpack_public_path__ + "wetransfer-logo.e99057d4.png";